import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ActivitiesPage from "../pages/activites/page";
import DesertActivitiesPage from "../pages/activites/desert/page";
import SeaActivitiesPage from "../pages/activites/mer/page";
import ParksActivitiesPage from "../pages/activites/parcs/page";
import CoupleActivitiesPage from "../pages/activites/couple/page";
import FamilyActivitiesPage from "../pages/activites/famille/page";
import ContactPage from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/activites",
    element: <ActivitiesPage />,
  },
  {
    path: "/activites/desert",
    element: <DesertActivitiesPage />,
  },
  {
    path: "/activites/mer",
    element: <SeaActivitiesPage />,
  },
  {
    path: "/activites/parcs",
    element: <ParksActivitiesPage />,
  },
  {
    path: "/activites/couple",
    element: <CoupleActivitiesPage />,
  },
  {
    path: "/activites/famille",
    element: <FamilyActivitiesPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
